import { Routes, Route } from "react-router-dom";
import AuthSystem from "../appPage/AuthSystem";

export default function AppRouter() {
    return (
        <Routes>
            <Route path="/*" element={<AuthSystem />} />
        </Routes>
    );
}
